import styled from 'styled-components';
import { Inputs } from '@taxdown/piccolo-web';
import EmailInput from 'Components/UI/EmailInput';

export const Input = styled(EmailInput)`
  label {
    color: ${({ theme: { colors } }) => colors.dark_500};
  }
`;

export const PassInput = styled(Inputs.Password)`
  div {
    div {
      color: ${({ theme: { colors } }) => colors.green_600};
    }
  }
`;
